import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-background"
}
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, " Estimez la taille de votre box ", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Pour estimer la taille de votre box, merci de répondre à ces deux questions : ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("b", null, "Surface de votre logement : ", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" m")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, "Comment êtes-vous meublé ?", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { style: {"font-weight":"normal"} }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Peu ")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { style: {"font-weight":"normal"} }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Moyen ")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { style: {"font-weight":"normal"} }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Beaucoup ")
const _hoisted_25 = { id: "mobile-calc-result-div" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Vous avez besoin d'un box de ")
const _hoisted_27 = { id: "mobile-calc-result-value" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" m")
const _hoisted_29 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" pour stocker vos biens. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    mode: "out-in",
    name: "fade"
  }, {
    default: _withCtx(() => [
      (this.store.state.search.calc_shown === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", null, [
                _hoisted_4,
                _hoisted_5,
                _hoisted_6,
                _hoisted_7,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "mobile-calc-size",
                  min: "0",
                  step: "1",
                  required: "",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.size) = $event))
                }, null, 512), [
                  [_vModelText, this.size]
                ]),
                _hoisted_8,
                _hoisted_9,
                _hoisted_10,
                _hoisted_11,
                _hoisted_12,
                _hoisted_13,
                _createElementVNode("label", _hoisted_14, [
                  _hoisted_15,
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    name: "mobile-calc-amount",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.amount) = $event)),
                    value: "20"
                  }, null, 512), [
                    [_vModelRadio, this.amount]
                  ]),
                  _hoisted_16
                ]),
                _hoisted_17,
                _createElementVNode("label", _hoisted_18, [
                  _hoisted_19,
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    name: "mobile-calc-amount",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.amount) = $event)),
                    value: "12",
                    checked: ""
                  }, null, 512), [
                    [_vModelRadio, this.amount]
                  ]),
                  _hoisted_20
                ]),
                _hoisted_21,
                _createElementVNode("label", _hoisted_22, [
                  _hoisted_23,
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    name: "mobile-calc-amount",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.amount) = $event)),
                    value: "8"
                  }, null, 512), [
                    [_vModelRadio, this.amount]
                  ]),
                  _hoisted_24
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_27, _toDisplayString(Math.ceil( this.size / this.amount )), 1),
                    _hoisted_28,
                    _hoisted_29
                  ]),
                  _hoisted_30
                ], 512), [
                  [_vShow, this.size > 0]
                ])
              ]),
              _createElementVNode("a", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (this.store.state.search.calc_shown = false))
              }, "×")
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}